import { Route } from "react-router-dom";
import { _adr } from "../address";
import { ProtectedRoute } from "../tools/protectedRoute";
import Dashboard from "../components/dashboard/dashboard";

export const dashboardRoutes = [
	<Route key="dashboard" path={_adr.Root + _adr.Home} element={<ProtectedRoute role="global" element={Dashboard} />} />,
];
